<template>
  <div
    ref="COMMONBOOK"
    class="width-full h-fullVh bt relative fb-col-start-start common-book"
  >
    <div ref="commonTop">
      <md-searchbar
        v-model="keyword"
        placeholder="请输入老师姓名"
        class="bt bb"
      ></md-searchbar>
      <md-tabbar
        v-if="!keyword && tabIndex"
        v-model="tabIndex"
        class="bg-FFFFFF tabbar-content bb"
        indicatorColor="#171A1D"
      >
        <md-tabbar-item v-for="item in tabList" :key="item.id" :name="item.id">
          {{ item.text }}
        </md-tabbar-item>
      </md-tabbar>
    </div>
    <div
      class="scroll-y relative scroll-wrapper"
      id="SCROLLWRAPPER"
      :style="{
        'margin-bottom': `${paddingBottom}px`
      }"
    >
      <div :style="{ height: `${scrollHeight}px` }">
        <template
          v-if="
            (keyword && !searchList.length) ||
            (!keyword &&
              ((tabIndex === 1 && !courseList.length) ||
                (tabIndex === 2 && !classData.length)))
          "
        >
          <common-no-data class="no-record bg-F6F6F6">
            <div class="no-course no-item"></div>
            <p class="font-28 c-171A1D-40">{{
              keyword && !searchList.length ? '没有搜索到相关结果' : '暂无记录'
            }}</p>
          </common-no-data>
        </template>
        <div
          class="bread-crumbs width-full lh-44 pl-16 ff-medium nowrap scroll-x"
          v-if="!keyword"
        >
          <div>
            <span
              class="font-32 inline-block"
              @click="showLevel = 1"
              :class="showLevel === 2 ? 'c-006AFE' : 'c-171A1D-60'"
              >{{ tabIndex === 1 ? '学科组' : '班级组' }}</span
            >
            <template v-if="+showLevel === 2 && childName" class="inline-block">
              <i class="iconfont font-24 c-171A1D-40">&#xe68d;</i>
              <span class="font-32 c-171A1D-60 inline-block pr-16">{{
                childName
              }}</span>
            </template>
          </div>
        </div>
        <template v-if="showLevel === 1 && !keyword">
          <div
            class="item bg-FFFFFF p-0-16 fb fb-main-between fb-cross-center bb hidden"
            v-for="(course, index) in tabIndex === 1 ? courseList : classData"
            :key="index"
          >
            <div class="item-flex-1 font-34 c-171A1D text-ellipsis">
              {{ filterName(course.courseName, 6) || course.className }}
            </div>
            <!-- 代课课程必须一致 -->
            <div
              class="next c-006AFE font-34 pl-10"
              v-if="
                course.hasTeacher &&
                (tabIndex === 1
                  ? course.courseId === selectSection.courseId
                  : true)
              "
              @click="
                tabIndex === 1
                  ? showCourseChild(course)
                  : showClassChild(course)
              "
            >
              <i class="iconfont">&#xe714;</i>
              <span>下级</span>
            </div>
            <div class="next c-006AFE font-34 pl-10 no-teacher" v-else>
              <i class="iconfont">&#xe714;</i>
              <span>下级</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="item p-0-16 bg-FFFFFF fb fb-main-between fb-cross-center bb hidden"
            :class="
              child.teacherDingId === selectSection.teacherDingId ||
              child.disabled
                ? 'disabled'
                : ''
            "
            v-for="(child, index) in keyword ? searchList : childList"
            :key="index"
          >
            <div class="item-flex-1">
              <div
                class="fb fb-main-start fb-cross-center"
                @click.stop="itemClick(child)"
              >
                <md-checkbox
                  v-model="child.checked"
                  :disabled="
                    child.teacherDingId === selectSection.teacherDingId ||
                    child.disabled
                  "
                  class="font-34 c-171A1D"
                >
                  <span
                    class="people-avatar mr-12 ml-12 c-FFFFFF font-24 text-bold-400 text-center inline-block"
                  >
                    {{ child.teacherName | getTeacherName(child.teacherName) }}
                  </span>
                  <span
                    class="font-34 c-171A1D max-w-100 inline-block text-ellipsis align-middle people-name"
                    >{{ child.teacherName }}</span
                  >
                  <span
                    class="people-status ml-4 p-0-10 font-24 bd-radio-4 text-bold-400"
                    v-if="
                      child.existConflict &&
                      child.teacherDingId !== selectSection.teacherDingId
                    "
                    >冲突</span
                  >
                </md-checkbox>
              </div>
            </div>
            <div
              class="next c-006AFE font-34 pl-10"
              @click="lookSchedule(child)"
            >
              <span>查看课表</span>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div
      class="footer bg-FFFFFF p-0-16 h-auto pb-16"
      ref="footer1"
      v-show="conflictName"
    >
      <div class="font-30 c-171A1D-60 p-12-0">
        <i class="iconfont">&#xe680;</i>
        {{ conflictName | filterBeyondEllipsis }}老师的课程存在冲突。</div
      >
      <div class="font-26 fb fb-main-start fb-cross-center bt-8">
        <common-button @click="handlerSubmit">确定</common-button>
      </div>
    </div>
    <div
      class="footer font-26 fb fb-main-start fb-cross-center bt-8"
      ref="footer2"
      v-show="!conflictName"
    >
      <common-button @click="handlerSubmit">确定</common-button>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin'
import commonButton from './commonButton'
import API from '@/api'
import commonNoData from './commonNoData'
import { filterName } from '@/utils/comUtils'
export default {
  name: 'commonBook',
  mixins: [mixin],
  components: {
    commonButton,
    commonNoData
  },
  props: {
    selectSection: {
      type: Object,
      default: null
    }
  },
  filters: {
    filterBeyondEllipsis(text) {
      if (!text) {
        return text
      }
      return text.length < 6 ? text : text.slice(0, 6) + '···'
    },
    getTeacherName(name) {
      return name ? filterName(name, 2, '') : '-'
    }
  },
  data() {
    return {
      filterName,
      tabList: [
        {
          text: '学科组',
          id: 1
        },
        {
          text: '班级组',
          id: 2
        }
      ],
      keyword: '',
      scrollHeight: 0,
      tabIndex: null,
      childName: '',
      courseList: [],
      classData: [],
      showLevel: 1,
      childList: [],
      searchList: [],
      paddingBottom: ''
    }
  },
  computed: {
    conflictName() {
      let target = (this.keyword ? this.searchList : this.childList).filter(
        v => v.checked && v.existConflict
      )
      return (target[0] || {}).teacherName
    }
  },
  watch: {
    tabIndex(val) {
      if (val) {
        this.childName = ''
        this.showLevel = 1
        this.childList = []
      }
    },
    keyword(val) {
      if (val) {
        this.searchteacherwithconflict(val)
      }
      this.$nextTick(() => {
        document.getElementById('SCROLLWRAPPER').scrollTop = 0
      })
    }
  },
  created() {
    // 获取学科组
    this.getCommonSimpleList()
    // 获取班级组
    this.getSubstituteQueryClass()
    this.$nextTick(() => {
      this.tabIndex = 1
      this.methodToCalcScroll()
      document.body.scrollTop = document.documentElement.scrollTop = 0
    })
  },
  methods: {
    searchteacherwithconflict(teacherName) {
      API.searchteacherwithconflict({
        ...this.commonParams,
        ...this.commonTerm,
        selectSection: this.selectSection,
        teacherName
      })
        .then(res => {
          this.searchList = res
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    itemClick(child) {
      this.clearChecked(child.teacherDingId)
      this.$forceUpdate()
      this.methodToCalcScroll()
    },
    clearChecked(teacherDingId) {
      this.childList.map(v => {
        if (v.teacherDingId !== teacherDingId) {
          v.checked = false
        }
      })
    },
    lookSchedule(child) {
      if (child.teacherDingId === this.selectSection.teacherDingId) {
        return
      }
      this.$emit('lookSchedule', child)
    },
    handlerSubmit() {
      let list = this.keyword ? this.searchList : this.childList
      let target = list.filter(v => {
        return v.checked
      })
      this.$emit('handlerClose', target)
    },
    // 班级组
    showClassChild({ classDingId, className }) {
      this.childName = className
      API.queryClassTeacherWithConflict({
        ...this.commonParams,
        ...this.commonTerm,
        classDingId,
        selectSection: this.selectSection
      })
        .then(res => {
          this.showLevel = 2
          res.map(v => {
            v.checked = false
          })
          this.childList = res
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    // 学科组
    showCourseChild({ courseId, courseName }) {
      this.childName = courseName
      API.queryCourseTeacherWithConflict({
        ...this.commonParams,
        ...this.commonTerm,
        courseId,
        selectSection: this.selectSection
      })
        .then(res => {
          this.showLevel = 2
          res.map(v => {
            v.checked = false
          })
          this.childList = res
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    getCommonSimpleList() {
      API.getCommonSimpleList({
        ...this.commonParams,
        ...this.commonTerm,
        showHasTeacher: true,
        showFirstCourseId: this.selectSection.courseId
      })
        .then(res => {
          this.courseList = res
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    getSubstituteQueryClass() {
      API.getSubstituteQueryClass({
        ...this.commonParams,
        ...this.commonTerm,
        showHasTeacher: true,
        showFirstClassDingId: this.selectSection.classDingId
      })
        .then(res => {
          this.classData = res
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    methodToCalcScroll() {
      try {
        this.scrollHeight =
          this.$refs.COMMONBOOK.clientHeight -
          this.$refs.commonTop.clientHeight -
          30
        this.paddingBottom =
          this.$refs.footer1.clientHeight + this.$refs.footer2.clientHeight
      } catch (error) {
        // console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#SCROLLWRAPPER {
  z-index: 10;
}
.footer {
  z-index: 100;
}
:deep(.md-checkbox .md-checkbox__icon) {
  color: rgba(23, 26, 29, 0.24);
}

.common-book > div {
  width: 100%;
}
:deep(.md-tabbar) {
  overflow: inherit;
}
.item {
  cursor: pointer;
  padding-top: 13px;
  padding-bottom: 13px;
  height: 56px;
  .next {
    line-height: 30px;
    height: 30px;
    border-left: 1px solid rgba(17, 31, 44, 0.24);
    padding-left: 10px;
    text-align: left;
    &.no-teacher {
      color: rgba(0, 0, 0, 0.08);
    }
  }
  &.disabled {
    opacity: 0.6;
  }
  .people-avatar {
    width: 36px;
    height: 36px;
    line-height: 36px;
    background: #006afe;
    border-radius: 75px;
  }
  .people-status {
    height: 22px;
    line-height: 22px;
    background: rgba(255, 82, 25, 0.12);
    color: #ff5219;
  }
}
.no-record {
  .no-course {
    width: 180px;
    height: 180px;
    margin-bottom: 16px;
    &.no-item {
      background: url(~@/assets/images/no-data.png) no-repeat center top;
      background-size: 180px 180px;
    }
  }
}
.people-name {
  line-height: 0.96rem;
}
</style>
